import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ed860ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2ed860ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed860ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed860ac')) {
      api.createRecord('2ed860ac', component.options)
    } else {
      api.reload('2ed860ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ed860ac&scoped=true&", function () {
      api.rerender('2ed860ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/operation-center/supplier-deduction-manage/page/modules/edit-dialog/index.vue"
export default component.exports